import invariant from 'invariant';
import { isFSA } from 'flux-standard-action';
import {
  SENDING_REQUEST,
  REQUEST_ERROR,
  SHOW_PROGRESS_BAR,
  HIDE_PROGRESS_BAR,
  CHANGE_BUSINESS_TYPES_DATA,
  CHANGE_BUSINESS_CATEGORIES_ALL_DATA,
  CHANGE_BUSINESS_STARTS_DATA,
  CHANGE_BUSINESS_SALES_DATA,
  CHANGE_FORM_REGISTER,
  CHANGE_FORM_RESET_PASSWORD,
  SET_RESEND_VERIFICATION_EMAIL_STATE,
  SHOW_LOADING_SPINNER,
} from './types';

// The initial application state
const initialState = {
  businessCategoriesAllState: [],
  businessSalesState: [],
  businessStartsState: [],
  businessTypesState: [],
  currentlySending: false,
  error: {}, // error object - based on FSA (Flux Standard Action), this must be Error() object
  formRegState: {
    email: '',
    password: '',
    confpassword: '',
  },
  hasError: false, // determine if the currentState hasError
  loadingBar: 0,
  resendVerificationEmail: {
    isModalShow: false,
    headerMessage: 'Error',
    bodyMessage: '',
    modalStatus: '',
  },
  resetPasswordState: {
    token_error: true,
    message: '',
    userFullName: '',
  },
  showLoadingSpinner: false,
};

// Takes care of changing the application state
function reducer(state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(
      action
    )}`
  );

  const { payload = {}, error = null } = action;

  // check if action has key 'error' then hasError must be changed to true
  let hasError = false;
  if (error) {
    hasError = true;
  }

  switch (action.type) {
    case CHANGE_FORM_REGISTER:
      return { ...state, hasError, formRegState: payload.newFormRegState };
    case SENDING_REQUEST:
      return { ...state, hasError, currentlySending: payload.sending };
    case REQUEST_ERROR:
      return { ...state, hasError, error: payload.error };
    case SHOW_PROGRESS_BAR:
      return { ...state, hasError, loadingBar: state.loadingBar + 30 };
    case HIDE_PROGRESS_BAR:
      return {
        ...state,
        hasError,
        loadingBar: state.loadingBar > 0 ? state.loadingBar - 30 : 0,
      };
    case SHOW_LOADING_SPINNER:
      return {
        ...state,
        hasError,
        showLoadingSpinner: payload.showLoadingSpinner,
      };
    case CHANGE_BUSINESS_TYPES_DATA:
      return {
        ...state,
        hasError,
        businessTypesState: payload.newBusinessTypes,
      };
    case CHANGE_BUSINESS_CATEGORIES_ALL_DATA:
      return {
        ...state,
        hasError,
        businessCategoriesAllState: payload.newBusinessCategoriesAll,
      };
    case CHANGE_BUSINESS_STARTS_DATA:
      return {
        ...state,
        hasError,
        businessStartsState: payload.newBusinessStarts,
      };
    case CHANGE_BUSINESS_SALES_DATA:
      return {
        ...state,
        hasError,
        businessSalesState: payload.newBusinessSales,
      };
    case CHANGE_FORM_RESET_PASSWORD:
      return {
        ...state,
        hasError,
        resetPasswordState: payload.resetPasswordState,
      };
    case SET_RESEND_VERIFICATION_EMAIL_STATE:
      return {
        ...state,
        resendVerificationEmail: payload.resendVerificationEmail,
      };
    default:
      return { ...state, hasError: false, error };
  }
}

export default reducer;
